module.exports = __webpack_public_path__ + "img/3.ed6f2285.jpg";